<template>
  <div class="site-page nav-content-inset">
    <div class="site-page__inner">
      <div class="page-head">
        <h1 class="site-page__title">站内信</h1>
        <el-button type="primary" plain :disabled="!hasUnread" @click="markAllRead">全部标为已读</el-button>
      </div>
      <el-table :data="items" v-loading="loading" border @row-click="onRowClick">
        <el-table-column prop="source" label="来源" width="100" />
        <el-table-column prop="message" label="内容" min-width="280" />
        <el-table-column label="时间" width="170">
          <template #default="s">{{ formatTime(s.row.createdAt) }}</template>
        </el-table-column>
        <el-table-column label="状态" width="80">
          <template #default="s">{{ Number(s.row.isRead) === 1 ? '已读' : '未读' }}</template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="total > pageSize"
        class="pager"
        layout="prev, pager, next"
        :total="total"
        :page-size="pageSize"
        :current-page="page"
        @current-change="onPage"
      />
    </div>
  </div>
</template>

<script>
import { fetchUserMessages, markMessagesRead } from '@/utils/userHub'

export default {
  name: 'UserMessagesView',
  data() {
    return {
      loading: false,
      items: [],
      total: 0,
      page: 1,
      pageSize: 20
    }
  },
  computed: {
    hasUnread() {
      return this.items.some((row) => Number(row.isRead) !== 1)
    }
  },
  created() {
    this.load()
  },
  methods: {
    formatTime(ts) {
      if (!ts) return '—'
      if (typeof ts === 'string' && ts.includes('-')) return ts
      const n = Number(ts)
      if (!Number.isFinite(n) || n <= 0) return String(ts)
      if (n > 1e12) return new Date(n).toLocaleString()
      return new Date(n * 1000).toLocaleString()
    },
    async load() {
      this.loading = true
      try {
        const data = await fetchUserMessages({ page: this.page, pageSize: this.pageSize })
        this.items = data.items || []
        this.total = data.total || 0
      } catch (e) {
        this.$message.error(e.message || '加载失败')
      } finally {
        this.loading = false
      }
    },
    onPage(p) {
      this.page = p
      this.load()
    },
    async onRowClick(row) {
      if (!row?.id || Number(row.isRead) === 1) return
      try {
        await markMessagesRead([row.id])
        row.isRead = 1
      } catch (e) {
        this.$message.error(e.message || '标记已读失败')
      }
    },
    async markAllRead() {
      try {
        await markMessagesRead([])
        this.items = this.items.map((row) => ({ ...row, isRead: 1 }))
        this.$message.success('已全部标为已读')
      } catch (e) {
        this.$message.error(e.message || '标记已读失败')
      }
    }
  }
}
</script>

<style scoped>
.page-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}
.site-page__title { margin: 0; }
.pager { margin-top: 16px; justify-content: center; }
</style>
